import { ACTION_TYPES } from "./constants";

export const setTermsConfirmation = () => ({
  type: ACTION_TYPES.SET_TERMS_CONFIRMATION,
});
